import clsx from "clsx";
import { forwardRef } from "react";
import ReactSlider, { ReactSliderProps } from "react-slider";
import { twMerge } from "tailwind-merge";
import Button from "../button";

export type SliderSize = "sm" | "md" | "lg";

export interface SliderProps extends Omit<
  ReactSliderProps<number>,
  "min" | "max"
> {
  min: number;
  max: number;
  size?: SliderSize;
  valueFormater?: (value: number) => React.ReactNode;
}

const Slider = forwardRef<ReactSlider<number>, SliderProps>((props, ref) => {
  const {
    size = "md",
    step = 1,
    className,
    thumbClassName,
    trackClassName,
    valueFormater,
    ...rest
  } = props;

  return (
    <ReactSlider<number>
      ref={ref}
      step={step}
      className={twMerge(
        "flex-1 bg-slate-50 border border-slate-200 rounded-full relative",
        clsx({
          "h-8": size === "lg",
          "h-4": size === "md",
          "h-2": size === "sm",
        }),
        className
      )}
      thumbClassName={twMerge(
        "absolute top-0 !outline-hidden",
        clsx({
          "translate-y-0": size === "lg",
          "-translate-y-1/4": size === "md",
          "-translate-y-3": size === "sm",
        }),
        thumbClassName
      )}
      trackClassName={twMerge(
        clsx({
          "h-8": size === "lg",
          "h-4": size === "md",
          "h-2": size === "sm",
        }),
        trackClassName
      )}
      renderThumb={({ key, ...thumbProps }, state) => (
        <div key={key} {...thumbProps}>
          <Button
            size="sm"
            className={clsx("rounded-full", {
              "text-sm": size === "sm",
              "text-base": size === "lg",
            })}
          >
            {valueFormater?.(state.valueNow) ?? state.valueNow}
          </Button>
        </div>
      )}
      {...rest}
    />
  );
});

export default Slider;
